import { render } from "./APageHead.vue?vue&type=template&id=468e3d54&scoped=true"
import script from "./APageHead.vue?vue&type=script&lang=js"
export * from "./APageHead.vue?vue&type=script&lang=js"

import "./APageHead.vue?vue&type=style&index=0&id=468e3d54&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-468e3d54"]])

export default __exports__